import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import './assets/icon/iconfont.css'
import VueKityminder from './index'

const app = createApp(App)

app.use(ElementPlus, { locale })
app.use(VueKityminder)

app.config.globalProperties.$filters = {
  format_number(num) {
    if (num === '')
      return '';
      
    let value = new Number(num);

    if (isNaN(value))
      return num;

    let unit = '';
    var k = 10000,
    sizes = ['', '万', '亿', '万亿'],
    i;

    if (value < k) {
      // vue-cli don't allow asign to self
      // value = value;
    }
    else {
      i = Math.floor(Math.log(value) / Math.log(k));
      value = ((value / Math.pow(k, i))).toFixed(2);
      unit = sizes[i];
    }

    return value+unit;
  }
};

app.mount('#app');
